/* eslint-disable max-len */
import PropTypes from 'prop-types';
import React, { useState } from 'react';

import Form from '../MainForm';
import SignatureCheckboxs from './SignatureCheckboxs';
import useDeclarationData from '../../../hooks/useDeclarationData';

const DeclarationForm = ({ EnableSpinner, SubmitSignatureForm }) => {
  const [values, setValues] = useState(useDeclarationData());

  const handleSubmit = (event) => {
    event.preventDefault();
    EnableSpinner();
    SubmitSignatureForm({ ...values });
  };

  const updateField = (event) => {
    const { name, value } = event;
    values[name] = value;
    setValues({ ...values });
  };

  return (
    <Form onSubmit={handleSubmit}>
      <SignatureCheckboxs onChange={updateField} />
    </Form>
  );
};

DeclarationForm.propTypes = {
  EnableSpinner: PropTypes.func,
  SubmitSignatureForm: PropTypes.func,
};

DeclarationForm.defaultProps = {
  EnableSpinner: {},
  SubmitSignatureForm: {},
};

export default DeclarationForm;
